import React from 'react';
import ReactDOM from 'react-dom';

import Tally from './tally.js';
import registerServiceWorker from './registerServiceWorker';

import './assets/css/tally-components.css';
import './assets/css/tally-layout.css';

ReactDOM.render(<Tally />, document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js